export enum EPresenceStatus {
  CALL = 'In a Call',
  AVAILABLE = 'Available',
  BERIGHTBACK = 'Be right back',
  AWAY = 'Away',
  BREAK = 'Break',
  BUSY = 'Busy',
  NOT_DISTURB = 'Do not disturb',
  VACATION = 'Vacation',
  UNKNOWN = 'Unknown',
  OFFLINE = 'Offline',
  WRAP_UP = 'Wrap Up',
}

export enum EPresenceStatusApi {
  AVAILABLE = 'Available',
  BUSY = 'Busy',
  ON_A_CALL = 'OnACall',
  BERIGHTBACK = 'BeRightBack',
  AWAY = 'Away',
  BREAK = 'Break',
  OFFLINE = 'Offline',
  VACATION = 'Vacation',
  NOT_DISTURB = 'DoNotDisturb',
  UNKNOWN = 'Unknown',
  WRAP_UP = 'WrapUp',
  UNAVAILABLE = 'Unavailable',
}

export enum EStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  DEFAULT = 'default',
  PROCESSING = 'processing',
  WARNING = 'warning',
}
